import { observer } from "mobx-react-lite"
import React from "react"
import { SectionList, SectionListData } from "~/ui/primitives"
import { User } from "../../models"
import styled from '~/ui/styled'
import MentionListItem from "./mention-list-item"

interface Props {
  onSelect?: (item: User) => void
  userSections: SectionListData<User, { letter: string; data: User[] }>[]
}

const Letter = styled.Text`
  padding: 8px 12px;
  background-color: #e3e6ec;
  text-transform: uppercase;
  color: grey;
`

export const MentionList: React.FC<Props> = observer(({ onSelect, userSections }) => {
  return (
    <SectionList
      sections={userSections}
      keyExtractor={(item) => item.id.toString()}
      renderItem={({ item }) => <MentionListItem user={item} onSelect={onSelect} />}
      renderSectionHeader={({ section: { letter } }) => <Letter>{letter}</Letter>}
    />
  )
})
